// extracted by mini-css-extract-plugin
module.exports = {"root":"Map_root___Co6Z","imageWrapper":"Map_imageWrapper__Gi4s6"};